module.exports = __webpack_public_path__ + "static/img/detailpz.c01bf66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailpz.jpg
// module id = 3xSP
// module chunks = 5